import React from "react";

function PageLoader() {

    return (
        <>
            <div id="preloader"></div>
        </>
    )
}

export default PageLoader;